import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, take, map } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AutoLoginGuard implements CanActivate {

  constructor(private router: Router, public authService: AuthService) { }

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.isAuthenticated.pipe(
      filter(val => val !== null),
      take(1),
      map(authenticated => {
        if (authenticated) {
          return this.router.createUrlTree(['/dashboard']);
        } else {
          return true;
        }
      })
    )
  }

}
